import Image from "next/image";

import cx from "@/utils/cx";
import { View } from "./main";
import { dataContext } from "@/contexts/cohort-data";
import { GetCohortDetailsResponse } from "@/queries/get-cohort-details.types";
import { useContext } from "react";
import dynamic from "next/dynamic";

const Footer = dynamic(() => import("./footer"), { ssr: false });

const Player = dynamic(() => import("@/components/player"), {
  ssr: false,
});

const LinkifyText = dynamic(() => import("@/components/linkify-text"), {
  ssr: false,
});

const Info = ({
  title,
  description,
  introUrl,
  view,
  onUpdateView,
}: GetCohortDetailsResponse & {
  view: View;
  onUpdateView: (view: View) => void;
}) => {
  const { data } = useContext(dataContext);

  return (
    <div
      className={cx(
        "overflow-auto min-h-screen py-8 px-4 flex-col mb-28 pb-24 md:pb-0 md:mb-0 md:static md:w-full md:min-h-fit md:p-0 z-20",
        {
          flex: view === "PHONE_LANDING",
          "hidden md:flex": view !== "PHONE_LANDING",
        }
      )}
    >
      <div className="flex items-center mb-6 md:mb-3">
        {data.c_logo_url && (
          // eslint-disable-next-line @next/next/no-img-element
          <img
            alt={title}
            src={data.c_logo_url}
            className="md:hidden shrink-0 rounded-md h-4 w-auto object-contain mr-4"
          />
        )}
        <h2 className="text-lg md:text-2xl font-bold">{title}</h2>
      </div>

      {introUrl?.url ? (
        <Player
          load="idle"
          className="rounded-md overflow-hidden"
          src={introUrl.url}
          title={title || ""}
          poster={introUrl.imageUrl || ""}
          withSkin
        />
      ) : introUrl?.imageUrl ? (
        <div className="relative w-full aspect-video">
          <Image
            fill
            className="rounded-md object-cover"
            src={introUrl?.imageUrl}
            alt={data.title || ""}
          />
        </div>
      ) : null}

      <LinkifyText
        enableReadMore
        className="mt-6 md:mt-4 mb-2 font-medium whitespace-break-spaces"
        clamp={10}
        setInnerHtml
      >
        {description}
      </LinkifyText>

      <Footer onUpdateView={onUpdateView} />
    </div>
  );
};

export default Info;
